
const PoreznaStopa = function(DS) {
    return DS.defineResource({
        name: 'PoreznaStopa',
        endpoint: '/porezneStope'
    });
};

PoreznaStopa.$inject = ['DS'];


export {PoreznaStopa};



// WEBPACK FOOTER //
// ./app/models/poreznaStopa.js